import { Component, OnInit, Inject } from '@angular/core';
import { MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA, MatLegacyDialogRef as MatDialogRef, MatLegacyDialog as MatDialog } from '@angular/material/legacy-dialog';
import { Holding } from 'sharedweb/app.models';
import { EdisPopupComponent } from '../edis-popup/edis-popup.component';
import { ToastrService } from 'ngx-toastr';
import { NO_EDIS_TO_AUTHORIZE, NO_EDIS_TO_UNAUTHORIZE, MAX_EDIS_HOLDINGS_ACTION_WARNING, EDIS_VALIDATION_ERROR } from 'sharedweb/strings/edis.strings';
import { MatLegacyTabChangeEvent as MatTabChangeEvent } from '@angular/material/legacy-tabs';
import { MAX_EDIS_HOLDINGS } from 'sharedweb/helpers/shared-constants';
import { EDISAction } from 'sharedweb/app.structs';
import { EdisService } from 'sharedweb/providers/edis/edis.service';
import { EDISStatusResponse, EdisAuthUnauth } from 'src/app/app.interfaces';
import { EdisChecked } from 'src/app/app.structs';

@Component({
  selector: 'app-authorization-holdings-selector',
  templateUrl: './authorization-holdings-selector.component.html',
  styleUrls: ['./authorization-holdings-selector.component.scss']
})
export class AuthorizationHoldingsSelectorComponent implements OnInit {

  edisActions = EDISAction;
  selectedIndex: number = 0;
  displayedColumns = ['select', 'symbol','quantity'];

  /**
   * These three holdings array is used for display purpose (on tab change which array to display)
   * pending holdings -> holdings which needs to be authorized
   * authorized holdings -> holdings which can be unauthorized
   * selectedHoldingArr -> Array which is currently displayed (selected on the basis of tab index)
   */
  pendingHoldings: Holding[] = [];
  authorizedHoldings: Holding[] = [];
  selectedHoldingArr: Holding[] = [];
  
  pendingHoldingsSelectedCount = 0;
  authorizedHoldingsSelectedCount = 0;

  maxHoldingsWarning = MAX_EDIS_HOLDINGS_ACTION_WARNING;

  checkAll: boolean = false;
  holdings: Holding[];
  edisStatus: EDISStatusResponse;
  requestInProgress: boolean = false;
  constructor(
    @Inject(MAT_DIALOG_DATA) public data: EdisAuthUnauth ,
    private _dialogRef: MatDialogRef<AuthorizationHoldingsSelectorComponent>,
    private _dialog: MatDialog,
    private _toastr: ToastrService,
    private edisService: EdisService
  ) { 
    this.selectedHoldingArr = this.pendingHoldings;
  }

  ngOnInit(): void {
    this.holdings = this.data.selectedHolding ? this.data.selectedHolding : this.data.holdings;
    this.edisQuantityUpdate();
  }
  
  edisQuantityUpdate() {
    /*
    RE-327 Here from server we fetch auth quantity and cancel quantity from getEDISQuantity call, which is used to calculate and show
     the quantity in auth and unauth tab for performing edis.
    */
    this.requestInProgress = true;
    this.edisService.getEDISQuantity().subscribe((edisStatus: EDISStatusResponse) => {
      this.edisStatusResponse(edisStatus);
    }, (error)=> {
      console.log('Error while fetching EDIS status',error);
      this.edisStatusResponse();
    })
  }

  edisStatusResponse(edisStatusResponse?: EDISStatusResponse) {
    this.edisStatus = edisStatusResponse || { auth_status: {}, cancel_status: {}};
    this.segregateHoldings();
    this.requestInProgress = false;
  }

  processAuthStatus(holding: Holding) {
    const authStatus = this.edisStatus?.auth_status || {};
    if (authStatus[holding.isin]) {
      holding.edis_auth_qty = authStatus[holding.isin];
    }
  }

  processCancelStatus(holding: Holding) {
    const cancelStatus = this.edisStatus?.cancel_status || {};
    if (cancelStatus[holding.isin]) {
      holding.edis_cancel_qty = cancelStatus[holding.isin].cancel_qty;
      holding.transactions = cancelStatus[holding.isin].transaction || [];
    }
  }

   edisPendingQty(holding) {
    // RE-608 Subtracting from Balance Qty not total Qty.
    return holding.outStandingQty - holding.edis_auth_qty;
  }
  
  segregateHoldings() {
    this.holdings?.forEach((holding)=>{
      this.processAuthStatus(holding);
      this.processCancelStatus(holding);

      if(holding.edis_cancel_qty) {
        if(this.authorizedHoldingsSelectedCount < MAX_EDIS_HOLDINGS && !this.data.selectedHolding) {
          holding.unauth_checked = true;
          this.authorizedHoldingsSelectedCount++;
        }
        else {
          /**
           * in some cases where selected holdings after 100+ index and then close the popup.
           * when user open the popup again top 100 holdings + the the holding user selected previously will be selected as holding.isChecked was true.
           */
          holding.unauth_checked = false;
        }
        this.authorizedHoldings.push(holding);
      } if(this.edisPendingQty(holding) > 0) {
        holding.selected_auth_quantity = this.edisPendingQty(holding);
        if(this.pendingHoldingsSelectedCount < MAX_EDIS_HOLDINGS && !this.data.selectedHolding) {

          holding.auth_checked = true;
          this.pendingHoldingsSelectedCount++;
        }
         else if(this.data.selectedHolding[0] && this.data.selectedHolding[0].isin == holding.isin){
          holding.auth_checked = true;
          this.pendingHoldingsSelectedCount++;
         } else { 
          holding.auth_checked = false;
        }
        this.pendingHoldings.push(holding);
      }
    })
      this.pendingHoldings.length && (this.checkAll = true);
  }

  tabCheck() {
    return  (this.selectedIndex) ? EdisChecked.unauthChecked : EdisChecked.authChecked;
  }

  openEDISPopup() {
    const isCheckedStatus = this.tabCheck();
    const selectedHoldings = [];
    for(let holding of this.selectedHoldingArr){
      if(holding[isCheckedStatus]) {
        if(+holding.selected_auth_quantity > 0) {
        selectedHoldings.push({
          ...holding,
          quantity: this.selectedIndex ? holding.edis_auth_qty : holding.selected_auth_quantity,
        });        
      } else if(+holding.selected_auth_quantity === 0) {
        this._toastr.error(EDIS_VALIDATION_ERROR);
        return;
      }   
    } 
    }
    if(selectedHoldings.length) {
        this._dialog.open(EdisPopupComponent, {
            minHeight: 300,
            width: '900px',
            panelClass: 'expanding-dialog',
            data: {
              selectedHoldings : selectedHoldings,
              action: this.selectedIndex ? EDISAction.Unauthorize : EDISAction.Authorize
            }
        }).afterClosed().subscribe((cdslDone)=>{
          if(cdslDone) {
            this._dialogRef.close();
          }
        })
    } else {
        this._toastr.error(this.selectedIndex ? NO_EDIS_TO_UNAUTHORIZE : NO_EDIS_TO_AUTHORIZE, 'Error');
    }
  }

  onTabChange(event: MatTabChangeEvent) {
    this.checkAll = false;
    this.selectedIndex = event.index;
    this.selectedHoldingArr = event.index ? this.authorizedHoldings : this.pendingHoldings;
    this.updateCheckAllStatus();
  }

  /**
     * 
     * @param checked checkbox check status.
     * @param holdingRow holding to which operation needs to be done.
     * after changing holding check status check if all holding whose can be done is checked or not or max EDIS holdings limit is reached.
  */
    markCheckedStatus(checked: boolean, holdingRow: Holding) {
      
      if(checked) {
        if(this.selectedIndex){
          this.authorizedHoldingsSelectedCount++;
        } else {
          this.pendingHoldingsSelectedCount++;
        }
      } else {
          if(this.selectedIndex){
            this.authorizedHoldingsSelectedCount--;
          } else {
            this.pendingHoldingsSelectedCount--;
          }
      }
      const isCheckedStatus = this.tabCheck();
      holdingRow[isCheckedStatus] = checked;
      this.updateCheckAllStatus();
  }

  updateCheckAllStatus() {
    const isCheckedStatus = this.tabCheck();
    const allHoldingChecked = this.selectedHoldingArr.every((holding)=>{
      return holding[isCheckedStatus];
    })
    if(allHoldingChecked){
      this.checkAll = true;
    } else if((this.selectedIndex && this.authorizedHoldingsSelectedCount >= MAX_EDIS_HOLDINGS) || (!this.selectedIndex && this.pendingHoldingsSelectedCount >= MAX_EDIS_HOLDINGS)){
      this.checkAll = true;  
    } else {
      this.checkAll = false;
    }
  }

  selectAll(checked: boolean) {
    if(checked) {
        this.fillHoldings();
    } else {
        this.clearSelection();
    }
    this.checkAll = checked;
  }

  clearSelection() {
    if(this.selectedIndex){
      this.authorizedHoldingsSelectedCount = 0;
    } else {
      this.pendingHoldingsSelectedCount = 0;
    }
    for(let holding of this.selectedHoldingArr) {
      const isCheckedStatus = this.tabCheck();
        if(holding[isCheckedStatus]) {
            holding[isCheckedStatus] = false;
        }
    }
  }

  /**
   * Called when selecting top 100 holdings.
   * need to sort data before checking as user may have sort data with specific column.
   * check in the loop until max holding edis limit is reached.
   * for each holding check if holding is selected previously or holding edis is already done.
   */
  fillHoldings() {
    const isCheckedStatus = this.tabCheck();
      for(let i=0; i < this.selectedHoldingArr.length; i++) {
          if(!this.selectedHoldingArr[i][isCheckedStatus]) {
            this.selectedHoldingArr[i][isCheckedStatus]=true;
            if(this.selectedIndex){
              this.authorizedHoldingsSelectedCount++;
              if(this.authorizedHoldingsSelectedCount == MAX_EDIS_HOLDINGS){
                break;
              }
            } else {
              this.pendingHoldingsSelectedCount++;
              if(this.pendingHoldingsSelectedCount == MAX_EDIS_HOLDINGS) {
                break;
              }
            }
          }
      }
  }

}
